import Button from "@components/button";
import OptionsIcon from "@components/icons/options-icon";
import { Text, View } from "dripsy";
import * as React from "react";

function FilterButton({ onPress, count }: { onPress: () => void; count: number }) {
  // const py = useResponsiveValue(["$1", "$2", "$2"]);
  return (
    <Button
      outline
      onPress={onPress}
      px="$3"
      py="$1"
      right={
        count > 0 ? (
          <View
            sx={{
              backgroundColor: "$primary",
              width: 20,
              height: 20,
              justifyContent: "center",
              borderRadius: 360,
            }}
          >
            <Text sx={{ fontSize: 11, alignSelf: "center", color: "$background" }}>{count}</Text>
          </View>
        ) : (
          <OptionsIcon size={14} color="$primary" />
        )
      }
    >
      Filteren
    </Button>
  );
}
export default FilterButton;
